import React, { FC } from 'react';
import { PageTitle, PageLink } from '../../../_mexablock/layout/core';
import { View } from './components/View';

const breadCrumbs: Array<PageLink> = [];

const AdminDistribuidorPage: FC = () => {
  return (
    <>
      <PageTitle breadcrumbs={breadCrumbs}>Distribuidores</PageTitle>
      <View />
    </>
  );
};

export { AdminDistribuidorPage };
